// extracted by mini-css-extract-plugin
export default {"visuallyhidden":"header-secondary__visuallyhidden--FMDKf","focusable":"header-secondary__focusable--XBUvI","container":"header-secondary__container--lqtSB"};